import { render, staticRenderFns } from "./LiveStockCategories.vue?vue&type=template&id=07373e60&"
import script from "./LiveStockCategories.vue?vue&type=script&lang=js&"
export * from "./LiveStockCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports